import React from "react";
export class FullHeightContainer extends React.Component<FullHeightContainerProps, any>{
    render() {
        return (
            <div style={this.props.style} 
                 className={"flex-container flex-container__item " + (this.props.classes ? this.props.classes : "")} 
                 ref={(r) => this.props.onRef ? this.props.onRef(r) : null}
                 data-context={this.props.context}
                 data-search-type={this.props.searchType}
                 id={this.props.id}>
                 {this.props.children}
            </div>
        );
    }
}

interface FullHeightContainerProps extends React.PropsWithChildren {
    classes?: string;
    context?: string;
    searchType?: string;
    style?: React.CSSProperties;
    onRef?: (ref: HTMLElement) => void;
    id?: string;
}